import axios from "../../helpers/httpClient";

export default {
    editProfile: async ({ state, commit, dispatch }, obj) => {
        const stateData = state.headerProfile
        try {
            // Start loader
            commit('SET_LOADER', true);

            let userConfiguraciones = await axios.post(`/information/private/editarProfile`, obj);

            // Stop Loader
            commit('SET_LOADER', false);

            if (userConfiguraciones.status === 200) {
                dispatch('activeMessageCorrect', 'Usuario editado con exito')
                commit('SET_HEADER_PROFILE', {...stateData, ...obj});
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
    updatePassword: async ({ state, commit, dispatch }, Password) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            let mensaje = await axios.put(`/information/private/updatepassword`, {Password});

            // Stop Loader
            commit('SET_LOADER', false);

            if (mensaje.status === 200) {
                dispatch('activeMessageCorrect', 'Contraseña cambiada con exito')
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    }
}